// See https://www.rainbowkit.com/docs/installation#vite

window.global = window.global ?? window;
window.process = window.process ?? { env: {} };

export {};
